import { getNextSibling, currentlyInSpace, currentlyInEm, insertBrackets, insertFromClipboard, closestParentOfType, generateNodeArray, generateRangeFromNodeArray, insertBracket } from '../../services/editor-manipulation.js';

// Don't worry about striking content. That isn't part of their normal workflow.
// We can float it during the meeting after this initial stuff
// Need to get double enactcls (or sections) working on pasting
// Also get word clean up going, try to find governors recs

// Need to reintegrate all the workflow stuff
// Also the back to list float doesnt work. Maybe make something absolute that stay over top of it while its in the corner?

tinymce.PluginManager.add('bracketbuttons', function (editor) {
    editor.ui.registry.addToggleButton('bracketbutton', {
        text: "[ ]",
        tooltip: "Insert Brackets",
        onAction: function () {
            insertBrackets(editor, false);
        }
    });
    editor.ui.registry.addToggleButton('lBracketbutton', {
        text: "[",
        tooltip: "Insert Left Bracket",
        onAction: function () {
            insertBracket(editor, '[');
        }
    });
    editor.ui.registry.addToggleButton('rBracketbutton', {
        text: "]",
        tooltip: "Insert Right Bracket",
        onAction: function () {
            insertBracket(editor, ']');
        }
    });
    editor.ui.registry.addToggleButton('pasteWithBrackets', {
        text: '[ \u0372 ] ',
        tooltip: "Paste with Brackets",
        onAction: async () => {
            const currentRange = editor.selection.getRng();
            const { collapsed } = currentRange;
            if (collapsed) {
                insertBrackets(editor, true);
            }
        }
    })
});

